import $ from 'jquery';
import Isotope from 'isotope-layout';
import AOS from "aos";

$(window).on('load', function() {
    const listingSelector = '.podcastListing';
    $(listingSelector).each(function (index, element) {
        const $listing = $(element);
        const $filters = $listing.find(listingSelector + '__filters');
        const $filterDropdown = $filters.find('select');
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        let filterValue = '*';

        const isotope = new Isotope(listSelector, {
            itemSelector: itemSelector,
            //layoutMode: 'fitRows',
            filter: isotopeFilter
        });

        function applyIsotopeFilter() {
            isotope.arrange();
            AOS.refresh();
        }

        function isotopeFilter() {
            return filterValue === '*' || $(this).hasClass( filterValue );
        }

        $filterDropdown.on('change', function(e) {
            filterValue = $(this).val();
            applyIsotopeFilter();
        });
        $filterDropdown.trigger('change');
    });
});